import React from 'react'
import PropTypes from 'prop-types'

const SortUpdatedServiceCard = (props) => {
  let classArrow = ''
  if (props.productsProfile.sort.active === 'updatedAt') {
    classArrow = props.productsProfile.sort.updatedAt.toLowerCase()
  }
  return (
    <button
      className={`sort-header ${classArrow}`}
      onClick={props.toggleSortProductByProfile(props.productsProfile.sort, props.profileId)}
    >
      Last Updated
    </button>
  )
}

SortUpdatedServiceCard.propTypes = {
  toggleSortProductByProfile: PropTypes.func.isRequired,
  productsProfile: PropTypes.shape({
    sort: PropTypes.shape({
      active: PropTypes.string.isRequired,
      updatedAt: PropTypes.string.isRequired,
    }),
  }).isRequired,
  profileId: PropTypes.string.isRequired,
}

export default SortUpdatedServiceCard
